function runAfterDingDoongLoads() {
    const widget = document.querySelector('.ot-dingdoong-main');
    if (widget) {
        const container = document.querySelector('.cart__summary');
        const heading = document.createElement('h5');
        heading.classList.add('h5');
        heading.innerText = 'Delivery';

        container.insertBefore(heading, container.firstChild);

        const postCodeInput = widget.querySelector('[name="zip-code"]');
        postCodeInput.setAttribute('placeholder', 'Enter postcode');
        postCodeInput.classList.add('input');

        const submitBtn = document.getElementById('delivery-validation-submit');
        if (submitBtn) {
            // submitBtn.classList.add('btn', 'btn--secondary', 'btn--icon-with-text', 'w-full');
        }

        observer.disconnect();
    }
}

const observer = new MutationObserver(() => {
    runAfterDingDoongLoads();
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});
